const icons = {
    "jmv_flix": {
        "Lesson": "mdi mdi-play-circle",
        "Module": "mdi mdi-animation-play",
        "Course": "mdi mdi-movie",
        "Topic": "mdi-poll-box",

        "Details-Lesson": "far fa-play-circle",
        "Details-Module": "fas fa-boxes",
        "Details-Course": "fas fa-film",
        "Details-Exercise": "far fa-check-circle",
    },
    "free_sale": {
        "Lesson": "mdi mdi-teach",
        "Module": "mdi mdi-package-variant-closed",
        "Course": "mdi mdi-book",
        "Exercise": "mdi mdi-border-color",
        "Topic": "mdi-poll-box",

        "Details-Lesson": "far fa-play-circle",
        "Details-Module": "fas fa-boxes",
        "Details-Course": "fas fa-book",
        "Details-Exercise": "far fa-check-circle",
    }
}

export default {
    computed: {
        appType() {
            return this.$getSettings ? this.$getSettings.settings.app_role : 'free_sale';
        },
    },
    methods: {
        contentIcon(type) {
            const content = type ? type : this.type;
            return icons[this.appType] && icons[this.appType][content] 
                ? icons[this.appType][content]
                : '';
        }
    },
}